/* eslint-disable @typescript-eslint/naming-convention */
import { commercialConstants } from '../../../../common/commercial-constants';
import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup, UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'is-workers-compensation',
    templateUrl: './workers-compensation.component.html',
    styleUrls: ['./workers-compensation.component.scss'],
    standalone: false
})
export class WorkersCompensationComponent implements OnInit {
    @Input() fnolForm: UntypedFormGroup;
    additionalInjuryDetail: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true });
    areaOfInjury: UntypedFormControl = new UntypedFormControl('', Validators.required);
    bodyPartOptions = [{
        Head: ['Multiple head injuries', 'Skull', 'Brain', 'Ear(s)', 'Eye(s)', 'Nose', 'Teeth', 'Mouth', 'Soft tissue (head)',
            'Facial bones'],
        'Upper extremeties - left': ['Multiple upper extremeties', 'Upper arm', 'Elbow', 'Lower arm', 'Wrist', 'Hand', 'Finger(s)',
            'Thumb', 'Shoulder', 'Wrist and hand'],
        'Upper extremeties - right': ['Multiple upper extremeties', 'Upper arm', 'Elbow', 'Lower arm', 'Wrist', 'Hand', 'Finger(s)',
            'Thumb', 'Shoulder', 'Wrist and hand'],
        Neck: ['Multiple neck injuries', 'Vertebrae', 'Disc (neck)', 'Spinal cord (neck)', 'Larynx', 'Soft tissue (neck)',
            'Trachea'],
        'Trunk and back': ['Multiple trunk injuries', 'Upper back area', 'Lower back area', 'Disc', 'Chest', 'Sacrum and coccyx',
            'Pelvis', 'Spinal cord', 'Internal organs', 'Heart', 'Lungs', 'Abdomen including groin', 'Buttocks',
            'Lumbar or sacral vertebrae'],
        'Multiple body parts': ['Artificial appliance', 'Unclassified - Insufficient info to properly identify',
            'Multiple body parts (including body systems & body parts)', 'Body systems & multiple body systems',
            'Whole body'],
        'Lower extremeties - left': ['Multiple lower appendages', 'Hip', 'Upper leg', 'Knee', 'Lower leg', 'Ankle', 'Foot',
            'Toes', 'Great toe'],
        'Lower extremeties - right': ['Multiple lower appendages', 'Hip', 'Upper leg', 'Knee', 'Lower leg', 'Ankle', 'Foot',
            'Toes', 'Great toe']
    }];
    bodyParts: string[] = [];

    causeOfInjury: UntypedFormControl = new UntypedFormControl('', Validators.required);
    causesOfInjuries: string[] = ['Abrasion', 'Burn/Scald or Freezing', 'Caught/Trapped', 'Cut/Punctured/Scraped', 'Fall/Slip/Trip',
        'Struck/Injured By', 'Miscellaneous', 'Motor Vehicle', 'Strain', 'Striking Against /Stepping On'];
    dateChecked = false;
    detailedBodyPart: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true });
    employeeEmail: UntypedFormControl = new UntypedFormControl('', Validators.pattern(commercialConstants.regexValidators.isValidEmail));
    employeeFirstName: UntypedFormControl = new UntypedFormControl('', [Validators.required,
    Validators.pattern(commercialConstants.regexValidators.nameField)]);
    employeeLastName: UntypedFormControl = new UntypedFormControl('', [Validators.required,
    Validators.pattern(commercialConstants.regexValidators.nameField)]);
    employeeOccupation: UntypedFormControl = new UntypedFormControl('', Validators.required);
    employeePhoneNumber: UntypedFormControl = new UntypedFormControl('', [Validators.required,
    Validators.pattern(/^[1-9]\d{2}-\d{3}-\d{4}$/)]);
    hiredDate: UntypedFormControl = new UntypedFormControl('',
        [Validators.required, Validators.pattern(/^(0[1-9]|1[012])[/](0[1-9]|[12][0-9]|3[01])[/](19|20)\d\d$/)]);
    hospitalizedAnswer: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true });
    injuryAreas: string[] = ['Head', 'Upper extremeties - left', 'Upper extremeties - right', 'Neck', 'Trunk and back',
        'Multiple body parts', 'Lower extremeties - left', 'Lower extremeties - right'];
    injuryDetail: UntypedFormControl = new UntypedFormControl('', Validators.required);
    injuryDetails: string[] = ['No Physical Injury', 'Amputation', 'Angina Pectoris', 'Asphyxiation', 'Burn', 'Concussion',
        'Contusion', 'Crushing', 'Dislocation', 'Electric Shock', 'Enucleation', 'Fracture', 'Freezing', 'Foreign Body',
        'Hearing Loss/Impairment', 'Heat Prostration', 'Hernia', 'Infection', 'Inflammation', 'Laceration/Open Wound',
        'Myocardial Infarction (Includes heart attack)', 'Other specific injury', 'Poisoning (Not overdose or cumulative injury)',
        'Puncture', 'Rupture', 'Severance', 'Sprain', 'Strain', 'Syncope', 'Vascular', 'Vision Loss'];
    injurySeverities: string[] = ['No Physical Injury', 'Minor (soft tissue)', 'Moderate', 'Major (hospitalization)', 'Fatality'];
    loseTime = false;
    lostDaysOfWorkAnswer: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true });
    maxSeverity = true;
    missDays = false;
    notifiedDate: UntypedFormControl = new UntypedFormControl('',
        [Validators.required, Validators.pattern(/^(0[1-9]|1[012])[/](0[1-9]|[12][0-9]|3[01])[/](19|20)\d\d$/)]);
    primaryTypesOfInjuries: string[] = ['Multiple Injuries', 'Cumulative Injury', 'Occupational Disease', 'Trauma'];
    returned = false;
    returnedDate: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true });
    severityOfInjury: UntypedFormControl = new UntypedFormControl('', Validators.required);
    timeFromWorkAnswer: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true });
    typeOfInjury: UntypedFormControl = new UntypedFormControl('', Validators.required);
    workersCompensationForm: UntypedFormGroup;

    constructor(private formBuilder: UntypedFormBuilder) { }

    buildForm(): void {
        this.fnolForm.addControl('workersCompensation', this.workersCompensationForm = this.formBuilder.group({
            employeeFirstName: this.employeeFirstName,
            employeeLastName: this.employeeLastName,
            employeePhoneNumber: this.employeePhoneNumber,
            employeeEmail: this.employeeEmail,
            employeeOccupation: this.employeeOccupation,
            hiredDate: this.hiredDate,
            causeOfInjury: this.causeOfInjury,
            typeOfInjury: this.typeOfInjury,
            severityOfInjury: this.severityOfInjury,
            areaOfInjury: this.areaOfInjury,
            injuryDetail: this.injuryDetail,
            detailedBodyPart: this.detailedBodyPart,
            additionalInjuryDetail: this.additionalInjuryDetail,
            hospitalizedAnswer: this.hospitalizedAnswer,
            timeFromWorkAnswer: this.timeFromWorkAnswer,
            lostDaysOfWorkAnswer: this.lostDaysOfWorkAnswer,
            returnedDate: this.returnedDate,
            notifiedDate: this.notifiedDate
        }));
    }
    checkHospitalized(): any {
        this.hospitalizedAnswer.valueChanges.subscribe((hosp) => {
            this.clearField(this.timeFromWorkAnswer);
            this.clearField(this.lostDaysOfWorkAnswer);
            this.clearField(this.returnedDate);
            if (hosp) {
                if (hosp === 'No') {
                    this.loseTime = true;
                    this.enableField(this.timeFromWorkAnswer);
                    this.clearField(this.lostDaysOfWorkAnswer);
                    this.clearField(this.returnedDate);
                    this.missDays = false;
                    this.returned = false;
                    this.checkLostTime();
                } else {
                    this.missDays = true;
                    this.loseTime = false;
                    this.returned = false;
                    this.enableField(this.lostDaysOfWorkAnswer);
                }
            } else {
                this.timeFromWorkAnswer.disable();
                this.lostDaysOfWorkAnswer.disable();
                this.returnedDate.disable();
                this.loseTime = false;
                this.returned = false;
                this.missDays = false;
            }
        });
    }
    checkLostTime(): any {
        this.timeFromWorkAnswer.valueChanges.subscribe((time) => {
            this.clearField(this.lostDaysOfWorkAnswer);
            this.clearField(this.returnedDate);
            if (time) {
                if (time === 'Yes') {
                    this.missDays = true;
                    this.returned = true;
                    this.enableField(this.lostDaysOfWorkAnswer);
                    this.returnedDate.enable();
                    this.returnedDate.setValidators(
                        [Validators.required, Validators.pattern(/^(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])(19|20)\d\d$/)]);
                } else {
                    this.lostDaysOfWorkAnswer.disable();
                    this.returnedDate.disable();
                    this.missDays = false;
                    this.returned = false;
                }
            } else {
                this.lostDaysOfWorkAnswer.disable();
                this.returnedDate.disable();
            }
        });
    }

    checkSeverity(): any {
        this.severityOfInjury.valueChanges.subscribe((severe) => {
            this.clearField(this.lostDaysOfWorkAnswer);
            this.clearField(this.hospitalizedAnswer);
            this.clearField(this.timeFromWorkAnswer);
            this.clearField(this.returnedDate);
            if (severe) {
                if (severe === 'Fatality' || severe === 'Major (hospitalization)') {
                    this.enableField(this.lostDaysOfWorkAnswer);
                    this.maxSeverity = true;
                    this.loseTime = false;
                    this.returned = false;
                    this.missDays = true;
                } else {
                    this.enableField(this.hospitalizedAnswer);
                    this.maxSeverity = false;
                    this.loseTime = false;
                    this.returned = false;
                    this.missDays = false;
                    this.checkHospitalized();
                }
            } else {
                this.lostDaysOfWorkAnswer.disable();
                this.hospitalizedAnswer.disable();
                this.timeFromWorkAnswer.disable();
                this.returnedDate.disable();
                this.maxSeverity = true;
                this.loseTime = false;
                this.returned = false;
                this.missDays = false;
            }
        });
    }
    clearField(field): any {
        field.setValue('');
        field.markAsUntouched();
        field.markAsPristine();
    }

    dateFilterChanged(check: boolean, field): void {
        if (check === true) {
            field.setValue('');
            field.disable();
        } else {
            field.enable();
        }
    }
    determineDetailedBodyParts(bodyPart): string[] {
        return this.bodyPartOptions[0][bodyPart];
    }
    enableField(field): any {
        field.enable();
        field.setValidators(Validators.required);
    }
    ngOnInit(): void {
        this.buildForm();
        this.areaOfInjury.valueChanges.subscribe((value) => {
            this.clearField(this.detailedBodyPart);
            if (value) {
                this.enableField(this.detailedBodyPart);
                this.bodyParts = this.determineDetailedBodyParts(value);
            } else {
                this.detailedBodyPart.disable();
            }
        });
        this.checkSeverity();
    }
}

